import axios from 'axios';
import Vue from 'vue';
// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('auth_request');
      axios
        .post('/auth/login', {
          username: userData.username,
          password: userData.password,
        })
        .then((response) => {
          console.log(response);
          const token = response.data.data.token;
          const user = response.data.data.name;
          const username = response.data.data.username;
          const role = response.data.data.role.name;

          localStorage.setItem('token', token);
          localStorage.setItem('usr', user);
          localStorage.setItem('username', username);
          localStorage.setItem('role', role);

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

          Vue.prototype.$role = role;
          // mutation to change state properties to the values passed along
          commit('auth_success', { token, user });
          resolve(response);
        })
        .catch((err) => {
          console.log('login error');
          commit('auth_error');
          localStorage.clear();
          reject(err);
        });
    });
  },
  async getUser({ commit }) {
    try {
      const response = await axios.get('/auth');
      commit('GET_LIST_USER', response.data);
      commit('GET_TOTAL_DATA', response.data.totalRecords);
      commit('GET_PAGE_NUMBER', response.data.pageNumber);
      commit('GET_PAGE_SIZE', response.data.pageSize);
      commit('GET_TOTAL_PAGE', response.data.totalPages);

      return response;
    } catch (e) {
      return e;
    }
  },
  async getKotaProvinsi({ commit }) {
    try {
      const response = await axios.get('/kotaprovinsis');
      commit('GET_LIST_KOTAPROVINSI', response.data);
      return response;
    } catch (e) {
      return e;
    }
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout');
      delete axios.defaults.headers.common['Authorization'];
      resolve();
    });
  },
};
